import { Box, Typography } from '@mui/material';
import type React from 'react';
import type { Tender } from '../../types/tender';

interface TenderScopeCardProps {
  tender: Tender;
}

const TenderScopeCard: React.FC<TenderScopeCardProps> = ({ tender }) => {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
      }}
    >
      <Typography variant="subtitle1" component="div">
        <strong>Details/Scope:</strong>
      </Typography>

      {tender.noFiles && (
        <Typography
          variant="body1"
          sx={{
            color: 'text.primary',
            fontWeight: 'bold',
            fontSize: '1.1rem',
            mt: 1,
            mb: 1,
          }}
        >
          Note: This is a notice-only tender. You must follow the{' '}
          {tender.tenderSourceURL ? (
            <a
              href={tender.tenderSourceURL}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'underline' }}
            >
              link to the original source page
            </a>
          ) : (
            'link to the original source page'
          )}{' '}
          to retrieve or access the full tender context and documents.
        </Typography>
      )}

      {tender.scope && (
        <>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: '1rem',
              mt: 1,
              fontWeight: 'bold',
              color: (theme) => theme.palette.greyLight,
            }}
          />
          <Typography
            variant="body2"
            sx={{
              fontSize: '1rem',
              whiteSpace: 'pre-wrap',
              maxHeight: '170px',
              overflowY: 'auto',
              p: 1,
              borderRadius: 1,
              mt: 0.5,
            }}
          >
            {tender.scope}
          </Typography>
        </>
      )}
      {!tender.scope && (
        <Typography variant="body2">No summary or scope details available.</Typography>
      )}
    </Box>
  );
};

export default TenderScopeCard;
